import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const TableBody: FunctionComponent<TParentComponentProps> = (props) => {
  return <ParentComponent {...props} />;
};

TableBody.defaultProps = {
  defaultClassName: 'cart-table__body',
  as: 'tbody',
};

export default TableBody;
